import attentionsActions, {
    GET_ATTENTIONS,
    GET_AFFILIATES,
    // [MODULE MIDDLEWARE] IMPORT ACTIONS
} from './attentions.actions';
import {services} from './attentions.services';

const attentionsMiddleware = ({dispatch, getState}) => (next) => (action) => {
    next(action);
    switch (action.type) {
        case GET_ATTENTIONS:
            services.getAttentions()
                .then((response) => dispatch(attentionsActions.getAttentionsSuccess(response)))
                .catch((error) => dispatch(attentionsActions.getAttentionsError(error)));
            break;
        case GET_AFFILIATES:
            services.getAffiliates()
                .then((response) => dispatch(attentionsActions.getAffiliatesSuccess(response)))
                .catch((error) => dispatch(attentionsActions.getAffiliatesError(error)));
            break;
        // [MODULE MIDDLEWARE] SWITCH CASE
        default: break;
    }
};

export default attentionsMiddleware;
